/**
 * The parties routes — TWO routes now, and the second is the one WT6's "ONE
 * route, and deliberately only one" header was waiting on.
 *
 * `parties/new` is a ROUTE, not a nav destination (WEB TIER A · WT6): it is
 * reached from the pickers' create rows carrying the `{ returnTo, name, draft }`
 * hand-off — or by a typed URL, which the page also survives (its header
 * records the `?return=` fallback).
 *
 * `parties/:partyId` is THE PARTY RECORD — the page OQ-PARTY-REFERRAL-WRITE §5
 * named as the missing half of the owner-ruled referral write, mounted by the
 * `feat/party-referral-screen` cluster. It is reached from the Parties report's
 * customer column (which pointed at the call-history page until this page
 * existed to own that click) and by URL. Gated `parties.view` at the server;
 * the screen renders the designed refusal rather than a blank page. Like
 * `party-calls` and `parties/new` before it, it gets NO nav row of its own —
 * the sidebar registry is an IA decision the owner rules on, and the `Parties`
 * row already lands a reader on the report one click away.
 *
 * ⚠ ORDER: `new` is declared BEFORE `:partyId` — the router ranks static
 * segments above dynamic ones anyway, but the declaration states the intent
 * (the `crfs/confirmations` precedent) so nobody re-orders them into a trap.
 *
 * ONE provider layout (`PartyProviders`, a `ToastProvider`): the record page's
 * referral save reports through a toast. `providers.tsx` records why the
 * create page riding inside it changes nothing for that page.
 */

import type { RouteObject } from 'react-router-dom';
import { PartyCreatePage } from './PartyCreatePage';
import { PartyRecordPage } from './PartyRecordPage';
import { PartyProviders } from './providers';

export const partiesRoutes: RouteObject[] = [
  {
    element: <PartyProviders />,
    children: [
      { path: 'parties/new', element: <PartyCreatePage /> },
      { path: 'parties/:partyId', element: <PartyRecordPage /> },
    ],
  },
];
